<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

let obj = {
  xData: ['2021','2022','2023'],
  legend: ['小麦', '玉米', '大豆'],
  lineData: [
    {
      name: '小麦',
      data: [147, 152, 152],
      color: '#1984ff',
    },
    {
      name: '玉米',
      data: [67.46, 75.46, 90.59],
      color: '#e7f90d',
    },
    {
      name: '大豆',
      data: [18.1, 16.72, 10.95],
      color: '#62dc34',
    },
    // {
    //   name: '花生',
    //   data: [2.5, 2.6, 2.6, 2.3, 2.7, 3.1],
    //   color: '#70c7fd',
    // },
    // {
    //   name: '芝麻',
    //   data: [3.01, 3.5, 3.6, 3.3, 3.9, 3.88],
    //   color: '#735ec7',
    // },
  ]
}
let serData = []
obj.lineData.forEach(item => {
  serData.push({
    name: item.name,
    type: "line",
    showSymbol: true,
    symbolSize: 8,
    symbol: "circle",
    lineStyle: {
      color: item.color,
    },
    itemStyle: {
      color: "#fff",
      borderColor: item.color,
      borderWidth: 2,
    },
    data: item.data,
  })
})


// 创建ECharts配置对象
const option = {
  // backgroundColor: "#0a2b45",
  // title: {
  //   text: '单位(元)',
  //   top: "2%",
  //   textAlign: "left",
  //   left: "5%",
  //   textStyle: {
  //     color: "#fff",
  //     fontSize: 14,
  //     // fontWeight: "600",
  //   },
  // },
  legend: {
    icon: 'circle',
    top: '3%',
    //   left: 'center',
    orient: 'horizontal', //图例方向【horizontal/vertical】
    itemHeight: 15, //修改icon图形大小
    itemWidth: 15, //修改icon图形大小
    selectedMode: true, //不允许点击图例
    itemGap: 20,
    textStyle: {
      fontSize: 12,
      color: '#fff',
      padding: [0, 8],
    },
    data: obj.legend,
  },
  tooltip: {
    show: true,
    trigger: "axis",
    backgroundColor: "#0a2b45", // 设置背景颜色
    textStyle: {
      color: '#fff',
      fontSize: 14,
    },
    borderColor: "rgba(255, 255, 255, .16)",
    axisPointer: {
      lineStyle: {
        color: "rgba(28, 124, 196)",
      },
    },

    formatter: (params) => {
      let arr = [...params];
      let str = '';
      arr.forEach((item, index) => {
        str += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' +
          obj.lineData[index].color +
          ';"></span>' + item.seriesName + '  ' + item.data + '万亩<br />';
      });
      str = arr[0].name + '<br />' + str;
      return str;
    },
  },


  grid: {
    top: "27%",
    left: "7%",
    right: "7%",
    bottom: "0%",
    containLabel: true,
  },
  xAxis: [
    {
      type: "category",
      axisLine: {
        lineStyle: {
          color: "#81b0d0",
        },
      },
      axisLabel: {
        interval: 0,
        align: "center",
        margin: 10,
        color: "#fff",
        rotate: 0,
        textStyle: {
          fontSize: 14,
        },
      },
      splitLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      boundaryGap: true,
      data: obj.xData,
    },
  ],

  yAxis: [
    {
      type: "value",
      name: "单位(万亩)",
      nameTextStyle: {
        //y轴上方单位的颜色
        color: "#fff",
      },
      // splitNumber: 6,
      axisLine: {
        show: true,
        lineStyle: {
          color: "#81b0d0",
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "rgba(221, 228, 241,.3)",
          // type: "dashed",
        },
      },
      axisLabel: {
        color: "#fff",
        textStyle: {
          fontSize: 14,
        },
      },
      axisTick: {
        show: false,
      },
    },
  ],
  series: serData,

};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);


    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
